import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
import ReportLineChart from '../ReportLineChart';

import noop from '../../utils/noop';
import getReportDescription from '../../utils/getReportDescription';

import './styles.css';

class ReportOverviewCard extends Component {
  getDescription() {
    return getReportDescription(this.props);
  }

  render() {
    const {
      title,
      subtitle,
      description,
      charts,
      handleClick,
      contactSales,
      contactSalesLink,
      isAppliance,
      quantityName,
      callToActionText
    } = this.props;

    return (
      <div className="report-overview-card-wrapper" onClick={handleClick}>
        <div className="report-overview-card">
          <div className="report-title-wrapper">
            <h2 className="report-details-title">
              <strong>
                {title}
              </strong>
              {description &&
                <Tooltip title={this.getDescription()} placement="bottom">
                  <span className="custom-icon custom-icon-circle custom-icon-small custom-icon-dark">
                    ?
                  </span>
                </Tooltip>}
            </h2>
            <p className="report-details-subtitle">
              {subtitle}
            </p>
          </div>
          {
            <div className="report-details-charts">
              {charts.map(chart =>
                <ReportLineChart
                  key={chart.type}
                  {...chart}
                  contactSales={contactSales}
                  contactSalesLink={contactSalesLink}
                  isOverview
                  isAppliance={isAppliance}
                  quantityName={quantityName}
                />
              )}
            </div>
          }
          <a className="report-overview-cta">
            {callToActionText}
          </a>
        </div>
      </div>
    );
  }
}

ReportOverviewCard.propTypes = {
  handleClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  charts: PropTypes.array,
  contactSales: PropTypes.func,
  contactSalesLink: PropTypes.string,
  isAppliance: PropTypes.bool,
  quantityName: PropTypes.string,
  callToActionText: PropTypes.string
};

ReportOverviewCard.defaultProps = {
  handleClick: noop,
  charts: [],
  callToActionText: 'View History'
};

export default ReportOverviewCard;
